import { IndicatorKeyEnum } from '../../models/IndicatorKeyEnum';
import {
  createInitialIndicatorProjectQuery,
  IndicatorProjectQueriesState,
  IndicatorProjectQuery,
} from '../../models/IndicatorProjectQuery';

export const PROJECTS_BY_COUNTRY_QUERY_KEY =
  IndicatorKeyEnum.PORTFOLIO_OVERVIEW_INCLUDING_REGIONAL_PROJECTS_BY_COUNTRY;

const idleQuery = createInitialIndicatorProjectQuery();

export const selectIndicatorProjectQuery = (
  state: { indicatorProjectQueries: IndicatorProjectQueriesState },
  queryKey: string,
): IndicatorProjectQuery => state.indicatorProjectQueries[queryKey] || idleQuery;

export const selectProjectsByCountryQuery = (
  state: { indicatorProjectQueries: IndicatorProjectQueriesState },
): IndicatorProjectQuery => selectIndicatorProjectQuery(state, PROJECTS_BY_COUNTRY_QUERY_KEY);
